export default __webpack_public_path__ + "static/media/working_remotely_status.10c45055.svg";